"use strict";
exports.__esModule = true;
function stringify(value) {
    return typeof value === 'object' ? JSON.stringify(value) : String(value);
}
exports.stringify = stringify;
